/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_about_budget_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Budget Boost — Predicts driver and constructor price changes before each race weekend based on historical performance patterns, recent PPM (points-per-million) trends.`)
};

const es_about_budget_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impulso de Presupuesto — Predice cambios de precio de pilotos y constructores antes de cada fin de semana de carrera basado en patrones de rendimiento histórico y tendencias recientes de PPM (puntos por millón).`)
};

const de_about_budget_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Budget Boost — Prognostiziert Preisänderungen von Fahrern und Konstrukteuren vor jedem Rennwochenende, basierend auf historischen Leistungsmustern und aktuellen PPM-Trends (Punkte pro Million).`)
};

const nl_about_budget_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Budget Boost — Voorspelt prijswijzigingen van coureurs en constructeurs vóór elk raceweekend op basis van historische prestatiepatronen en recente PPM-trends (punten-per-miljoen).`)
};

const fr_about_budget_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boost Budget — Prédit les changements de prix des pilotes et constructeurs avant chaque week-end de course basé sur les tendances de performance historiques et le PPM (points par million) récent.`)
};

const it_about_budget_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Budget Boost — Prevede le variazioni di prezzo di piloti e costruttori prima di ogni weekend di gara basandosi su pattern di prestazioni storiche e tendenze PPM (punti per milione) recenti.`)
};

const pt_br2_about_budget_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impulso de Orçamento — Prevê mudanças de preço de pilotos e construtores antes de cada fim de semana de corrida com base em padrões de desempenho histórico e tendências recentes de PPM (pontos por milhão).`)
};

const pt_about_budget_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impulso de Orçamento — Prevê alterações de preço de pilotos e construtores antes de cada fim de semana de corrida, com base em padrões históricos de desempenho e tendências recentes de PPM (pontos por milhão).`)
};

const ja_about_budget_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バジェットブースト — 過去のパフォーマンスパターンと最近のPPM（ポイント・パー・ミリオン）トレンドに基づき、レースウィークエンド前のドライバー・コンストラクター価格変動を予測。`)
};

const zh_about_budget_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预算助推 — 基于历史表现模式和近期PPM（每百万积分）趋势，在每个比赛周前预测车手和车队价格变动。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const about_budget_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.about_budget_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("about_budget_desc", locale)
	if (locale === "en") return en_about_budget_desc(inputs)
	if (locale === "es") return es_about_budget_desc(inputs)
	if (locale === "de") return de_about_budget_desc(inputs)
	if (locale === "nl") return nl_about_budget_desc(inputs)
	if (locale === "fr") return fr_about_budget_desc(inputs)
	if (locale === "it") return it_about_budget_desc(inputs)
	if (locale === "pt-BR") return pt_br2_about_budget_desc(inputs)
	if (locale === "pt") return pt_about_budget_desc(inputs)
	if (locale === "ja") return ja_about_budget_desc(inputs)
	return zh_about_budget_desc(inputs)
};